<template>
  <div>
    <div v-if="showOptions">
      <div
        v-for="(row, idx) in rows"
        :key="idx"
        class="card mb-2"
      >
        <div class="card-body py-2">
          <div class="d-flex align-items-center mb-2">
            <input
              type="text"
              :name="`options_rows[${idx}][key]`"
              v-model="row.key"
              class="form-control form-control-sm mr-2"
              style="max-width:200px"
              :placeholder="keyPlaceholder"
            >
            <button
              type="button"
              class="btn btn-sm btn-outline-danger ml-auto"
              @click="removeRow(idx)"
            >
              &times; {{ $t('user_field.common.delete') }}
            </button>
          </div>
          <div
            v-for="locale in locales"
            :key="locale"
            class="form-group row mb-1"
          >
            <label class="col-sm-2 col-form-label col-form-label-sm text-muted">
              {{ locale.toUpperCase() }}<span v-if="locale === defaultLocale"> *</span>
            </label>
            <div class="col-sm-10">
              <input
                type="text"
                :name="`options_rows[${idx}][label][${locale}]`"
                v-model="row.labels[locale]"
                class="form-control form-control-sm"
                :placeholder="locale === defaultLocale ? labelPlaceholder : ''"
                :required="locale === defaultLocale"
              >
            </div>
          </div>
        </div>
      </div>

      <button type="button" class="btn btn-sm btn-outline-secondary mt-1" @click="addRow">
        + {{ $t('user_field.fields.static_options_add') }}
      </button>
      <small class="form-text text-muted d-block mt-1">{{ $t('user_field.fields.static_options_hint') }}</small>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FieldOptions',
  props: {
    fieldType: {
      type: String,
      default: '',
    },
    locales: {
      type: Array,
      required: true,
    },
    defaultLocale: {
      type: String,
      required: true,
    },
    initialRows: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      currentType: this.fieldType,
      rows: this.initialRows.map(r => ({
        key: r.key,
        labels: Object.assign({}, r.label ?? {}),
      })),
    };
  },
  computed: {
    showOptions() {
      return this.currentType === 'select';
    },
    keyPlaceholder() {
      return this.$t('user_field.fields.static_options_key');
    },
    labelPlaceholder() {
      return this.$t('user_field.fields.static_options_label');
    },
  },
  mounted() {
    const typeSelect = document.getElementById('type');
    if (typeSelect) {
      typeSelect.addEventListener('change', (e) => {
        this.currentType = e.target.value;
      });
    }
  },
  methods: {
    addRow() {
      const labels = {};
      this.locales.forEach(l => { labels[l] = ''; });
      this.rows.push({ key: '', labels });
    },
    removeRow(idx) {
      this.rows.splice(idx, 1);
    },
  },
};
</script>
